import axios from "axios";
import storeInit from "../redux/store";
import { removeUser } from "../redux/features/users/UserSlice";
// import { api_Secret, api_key } from "../config/appSettings";

const axiosConfig = async (url, method = "get", body = null, others, type) => {
  // const store = storeInit.store.getState()?.user?.user;

  const token =
    storeInit.store.getState()?.user?.user?.data?.accessTokens?.token?.token ||
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  try {
    const response = await axios({
      url,
      method,
      data: body,
      headers: {
        Authorization: `Bearer ${token}`,
        source: "web",
        api_key: 1,
        api_Secret: 1,
      },
      // Use this for dev when going through port, don't use for gateway either for dev or prod environments
      // headers:
      //   type == "LOGIN"
      //     ? {
      //         Authorization: `Bearer ${token}`,
      //         source: "web",
      //       }
      //     : {
      //         Authorization: `Bearer ${token}`,
      //         source: "web",
      //         api_key,
      //         api_Secret,
      //       },
      ...others,
    });
    // console.log(`${url} -- ${response}`);
    return response;
  } catch (error) {
    // console.log("error", error);
    if (error.response && error.response.status === 401) {
      // Remove user from store
      storeInit.store.dispatch(removeUser());

      // Token expired, redirect to login page
      window.location.href = "/";
    }
    return error.response;
  }
};

export default axiosConfig;
